import Page from 'flarum/common/components/Page';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import app from 'flarum/forum/app';
import StoreItemComponent from '../components/StoreItemComponent';
import Button from 'flarum/common/components/Button';
import CreateItemModal from '../../forum/components/CreateItemModal';
import Select from 'flarum/common/components/Select';
import StoreItemUtils from '../utils/StoreItemUtils';
import { showIf } from '../utils/NodeUtil';
import Placeholder from 'flarum/common/components/Placeholder';
export default class StorePage extends Page {
  loading = false;
  record = [];
  filters = {};
  currentFilter = "all";
  oninit(vnode) {
    super.oninit(vnode);
    StoreItemUtils.getInstance().getFilterProviderDict(this.filters);
    this.currentFilter = {
      avatar: 'avatar_decoration',
      name: 'name_decoration',
      title: 'title_decoration',
      cover: 'cover_decoration'
    }[m.route.param('tab')] || 'all';
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.reloadItem();
  }
  view() {
    return m("div", null, m("div", {
      className: "container"
    }, m("div", {
      className: "sideNavContainer"
    }, m("nav", {
      className: "IndexPage-nav sideNav"
    }, m(IndexSidebar, null)), m("div", {
      class: "StoreListPage"
    }, m("div", {
      className: "store-heading"
    }, m("h2", null, "\u5546\u5E97"), app.session.user ? m("span", null, "\u79EF\u5206\u4F59\u989D\uFF1A", app.session.user.attribute('pointBalance') ?? 0, " \xB7 ", m("a", {
      href: app.route('user.purchase_history', {
        username: app.session.user.slug()
      })
    }, "\u6211\u7684\u7269\u54C1")) : m("span", null, "\u767B\u5F55\u540E\u53EF\u4F7F\u7528\u79EF\u5206\u8D2D\u4E70\u5E76\u88C5\u5907\u7269\u54C1")), m("div", {
      class: "store-list-title"
    }, m(Select, {
      options: this.filters,
      value: this.currentFilter,
      onchange: this.changeFilter.bind(this)
    }), !app.session.user?.canCreateStoreItem() ? '' : m(Button, {
      class: "Button Button--primary",
      onclick: this.create.bind(this)
    }, m("i", {
      class: "fas fa-plus"
    }), m("span", null, app.translator.trans('xypp-store.forum.create')))), m("div", {
      class: "StoreListContainer"
    }, showIf(this.loading, m(LoadingIndicator, null), showIf(!!this.record?.length, this.record.map(item => {
      return m(StoreItemComponent, {
        item: item,
        onSubmit: this.updateItem.bind(this),
        onDelete: this.itemHasDeleted.bind(this)
      });
    }), m(Placeholder, {
      text: app.translator.trans("xypp-store.forum.item.no_available")
    }))))))));
  }
  changeFilter(e) {
    this.currentFilter = e;
    this.reloadItem();
  }
  async reloadItem() {
    this.loading = true;
    m.redraw();
    let type = this.currentFilter;
    if (type == "all") type = undefined;
    this.record = await app.store.find('store-item', {
      type
    });
    this.loading = false;
    m.redraw();
  }
  create() {
    app.modal.show(CreateItemModal, {
      onSubmit: item => {
        this.record.push(item);
        m.redraw();
      }
    });
  }
  updateItem(item) {
    if (this.record.find(i => i.id() == item.id())) {
      this.record = this.record.map(i => i.id() == item.id() ? item : i);
    } else {
      this.record.push(item);
    }
    m.redraw();
  }
  itemHasDeleted(item) {
    if (this.record) this.record = this.record?.filter(i => i.id() != item.id());
    m.redraw();
  }
}
flarum.reg.add('xypp-store', 'forum/components/StorePage', StorePage);